import { render, staticRenderFns } from "./PurchaseDuoDeliveriesPerMonth.vue?vue&type=template&id=df571772&"
import script from "./PurchaseDuoDeliveriesPerMonth.vue?vue&type=script&lang=js&"
export * from "./PurchaseDuoDeliveriesPerMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports